import React from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation
import Header from './Header';
import Footer from '../Footer';

export default function Layout({ children }) {
  const location = useLocation(); // Get the current location

  return (
    <div className="wrapper">
      <Header />
      <main id="content-area">
        {children}
      </main>
      
      {/* Conditionally render the Footer */}
      {location.pathname !== '/token/rzto' && <Footer />}
    </div>
  );
}
